/**
 * Gamemaster Agent Types
 *
 * Pluggable AI gamemaster interface for solo play mode.
 * The AI DM communicates through structured commands (via tool-use)
 * and streams narration to chat. Provider-agnostic — Claude first,
 * with a slot for decibel-agent or other providers.
 */
export const DEFAULT_SOLO_AI_CONFIG = {
    gamemasterProvider: 'claude',
    model: 'claude-sonnet-4-5-20250929',
    tableStyle: 'HEROIC',
    temperature: 0.8,
    maxTokensPerTurn: 4096,
    conversationSummaryThreshold: 30000,
};
//# sourceMappingURL=gamemaster-types.js.map